import React from 'react';
import { InputNumberComponent } from '../../../../../components/prime-formik';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';

const SuperProfileMinimumOverallAssessmentScoreRequiredInput = () => {
  return (
    <div className="p-col-12">
      <div>
        <strong>Filter candidates using these SuperMatch benchmarks</strong>
      </div>
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.minimum-overall-assessment-score-required"
          defaultMessage="Minimum overall Job Profile score required"
        >
          {(text) => (
            <label className="field-label" htmlFor="minimumOverallAssessmentScoreRequired">
              {text}
            </label>
          )}
        </FormattedMessage>
        <div className="p-inputgroup right">
          <Field
            id="minimumOverallAssessmentScoreRequired"
            name="minimumOverallAssessmentScoreRequired"
            className="width-full"
            component={InputNumberComponent}
          />
          <span className="p-inputgroup-addon">%</span>
        </div>
      </div>
    </div>
  );
};

export default SuperProfileMinimumOverallAssessmentScoreRequiredInput;
